module.exports = __webpack_public_path__ + "static/media/ankora.4000efdc.jpg";